import React from "react";
import classes from "./Articles.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import useEmblaOverflow from "../../../hooks/useEmblaOverflow";
import format from "date-fns/format";
import { formatOrder } from "../../../utils/constants";

const Articles = ({ countryData, blogsData, blogsSectionData }: { countryData: any; blogsData: any[]; blogsSectionData: any }) => {
  const isMobile = useIsMobile(768);
  const { emblaRef, hasOverflow, canScrollPrev, canScrollNext, scrollPrev, scrollNext } = useEmblaOverflow();

  const renderCards = () =>
    blogsData?.map((article: any) => (
      <div className={classes["ar-slide"]} key={article.id}>
        <a href={`/blogs/${article.slug}`} target="_blank" aria-label={article.title}>
          <div className={classes["ar-card"]}>
            <div className={classes["ar-thumbnail"]}>
              <CustomImage
                src={article.blogLandingCardImage?.imageUrl || article.newimageUrl?.imageUrl || article.imageUrl || "/icons/placeholder-image.svg"}
                alt={article.blogLandingCardImage?.alt || article.newimageUrl?.alt || article.title}
                layout="fill"
                objectFit="fill"
              />
            </div>
            <div className={classes["ar-text-area"]}>
              {article.stu_dest_categories?.[0]?.category && <span className={classes["ar-category"]}>{article.stu_dest_categories[0].category}</span>}
              <h3 className={classes["ar-title"]}>{article.title}</h3>
              {article.shortDescription && <p className={classes["ar-description"]}>{article.shortDescription}</p>}
              {article.date && <p className={classes["ar-meta"]}>{format(new Date(article.date), formatOrder)}</p>}
            </div>
          </div>
        </a>
      </div>
    ));

  const arrowLeft = (
    <button
      className={`${classes["ar-arrow"]}${canScrollPrev ? "" : ` ${classes["ar-arrow-disabled"]}`}`}
      onClick={scrollPrev}
      disabled={!canScrollPrev}
      aria-label="Previous"
    >
      <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="left-arrow" />
    </button>
  );

  const arrowRight = (
    <button
      className={`${classes["ar-arrow"]}${canScrollNext ? "" : ` ${classes["ar-arrow-disabled"]}`}`}
      onClick={scrollNext}
      disabled={!canScrollNext}
      aria-label="Next"
    >
      <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="right-arrow" />
    </button>
  );

  if (!blogsData?.length) return null;

  return (
    <section id="blogs" className={classes["ar-section"]}>
      <div className={classes["ar-container"]}>
        <h2 className={classes["ar-heading"]}>{blogsSectionData?.title ?? ""}</h2>
        <div
          className={classes["ar-subtext"]}
          dangerouslySetInnerHTML={{
            __html: blogsSectionData?.description ?? "",
          }}
        ></div>

        {isMobile ? (
          <div className={classes["ar-carousel-wrap"]}>
            <div className={classes["ar-viewport"]} ref={emblaRef}>
              <div className={classes["ar-slider"]}>{renderCards()}</div>
            </div>
            {hasOverflow && (
              <div className={classes["ar-arrows-below"]}>
                {arrowLeft}
                {arrowRight}
              </div>
            )}
          </div>
        ) : (
          <>
            <div className={classes["ar-carousel-wrap"]}>
              <div className={classes["ar-viewport"]} ref={emblaRef}>
                <div className={classes["ar-slider"]}>{renderCards()}</div>
              </div>
            </div>

            {hasOverflow && blogsData.length > 3 && (
              <div className={classes["ar-arrows-container"]}>
                {arrowLeft}
                {arrowRight}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Articles;
